import { spacings } from '@constants/theme/spacing.config';
import styled from '@emotion/styled';

export const SadaMenuItem = styled.div`
  padding: ${spacings.xxs} ${spacings.lg};
`;
